import React from 'react';
import './Returns.css';

const Returns = () => {
  return (
    <div className="returns-page">
      {/* Hero Section */}
      <div className="returns-hero">
        <div className="returns-hero-content">
          <h1>Returns & Refunds</h1>
          <p>Easy returns and quick refunds for your peace of mind</p>
        </div>
      </div>

      <div className="returns-container">
        <div className="returns-content">
          <div className="returns-section">
            <h2>Return Policy</h2>
            <div className="policy-cards">
              <div className="policy-card">
                <div className="policy-icon">📅</div>
                <h3>30-Day Returns</h3>
                <p>Return most items within 30 days of delivery for a full refund</p>
              </div>
              <div className="policy-card">
                <div className="policy-icon">🔄</div>
                <h3>Easy Process</h3>
                <p>Start your return online and print a prepaid shipping label</p>
              </div>
              <div className="policy-card">
                <div className="policy-icon">💰</div>
                <h3>Quick Refunds</h3>
                <p>Refunds processed within 5-7 business days of receiving your return</p>
              </div>
            </div>
          </div>

          <div className="returns-section">
            <h2>How to Return an Item</h2>
            <div className="return-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Start Your Return</h3>
                  <p>Go to your order history and select the item you want to return. Click "Start Return" and choose your reason.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Print Label</h3>
                  <p>Download and print the prepaid return shipping label. Make sure to include it with your package.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Package Item</h3>
                  <p>Pack the item in its original condition with all tags attached. Include the return label and any original packaging.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-content">
                  <h3>Ship Back</h3>
                  <p>Drop off your package at any authorized shipping location. You'll receive a confirmation email once we receive it.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="returns-section">
            <h2>Return Requirements</h2>
            <div className="requirements-grid">
              <div className="requirement-item">
                <h3>✅ What's Required</h3>
                <ul>
                  <li>Item in original condition</li>
                  <li>All original tags attached</li>
                  <li>Original packaging included</li>
                  <li>Return label attached</li>
                  <li>Return within 30 days</li>
                </ul>
              </div>
              <div className="requirement-item">
                <h3>❌ What's Not Accepted</h3>
                <ul>
                  <li>Used or damaged items</li>
                  <li>Items without original tags</li>
                  <li>Personal care items (for hygiene)</li>
                  <li>Custom or personalized items</li>
                  <li>Items returned after 30 days</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="returns-section">
            <h2>Refund Information</h2>
            <div className="refund-info">
              <div className="refund-card">
                <h3>Refund Timeline</h3>
                <p>Once we receive your return, we'll process your refund within 5-7 business days. The refund will be issued to your original payment method.</p>
              </div>
              <div className="refund-card">
                <h3>Shipping Costs</h3>
                <p>Return shipping is free for most items. If you choose expedited shipping for your return, you'll be responsible for the additional cost.</p>
              </div>
            </div>
          </div>

          <div className="returns-section">
            <h2>Need Help?</h2>
            <p>If you have questions about returns or need assistance, our customer service team is here to help!</p>
            <div className="contact-options">
              <div className="contact-option">
                <div className="option-icon">📧</div>
                <h3>Email Support</h3>
                <p>returns@inifiy.com</p>
                <span>Response within 24 hours</span>
              </div>
              <div className="contact-option">
                <div className="option-icon">📞</div>
                <h3>Phone Support</h3>
                <p>+1 (555) 123-4567</p>
                <span>Mon-Fri, 9AM-6PM EST</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Returns; 